import { gql } from '@graphql/__generated__';

export const GET_SENDER_DETAILS = gql(/* GraphQL */ `
  query getSenderDetails($id: uuid!) {
    users_by_pk(id: $id) {
      id
      ...EmailSender
    }
  }
`);

export const UPSERT_EMAIL_TEMPLATE = gql(/* GraphQL */ `
  mutation upsertEmailTemplate(
    $listingId: uuid!
    $emailTemplateId: uuid!
    $listingUpdates: lots_set_input!
    $emailTemplate: email_templates_insert_input!
    $files: [email_templates_files_insert_input!]!
  ) {
    insert_email_templates_one(
      object: $emailTemplate
      on_conflict: {
        constraint: email_templates_pkey
        update_columns: [
          name
          add_signature
          bcc
          cc
          is_shared_with_everyone
          is_shared_with_organisation
          subject
          subject_plaintext
          text
          text_html
          text_plaintext
        ]
      }
    ) {
      id
      ...EmailTemplateForm
    }
    delete_email_templates_files(
      where: { email_template_id: { _eq: $emailTemplateId } }
    ) {
      affected_rows
    }
    insert_email_templates_files(objects: $files) {
      returning {
        email_template_id
        file_id
      }
    }
    update_lots_by_pk(pk_columns: { id: $listingId }, _set: $listingUpdates) {
      id
      ...ListingEnquiryResponseEmail
      ...ListingBuyersAutoMatchingEmail
    }
  }
`);

export const EMAIL_SENDER_FRAGMENT = gql(/* GraphQL */ `
  fragment EmailSender on users {
    ...EmailUser
    branding_logo
    branding_color
    branding_name
    branding_website
    user_images(where: { is_primary: { _eq: true } }, limit: 1) {
      id
      image {
        id
        url
      }
    }
    nylas_account: logins(where: { provider: { _eq: "nylas-v3" } }) {
      __typename
    }
  }
`);
